export default __webpack_public_path__ + "static/media/Group451@2x.c891d68b.png";